import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { analyticsApi } from '@/api';
import { templateKeys } from '@/lib/queryKeys';
import { GC_TIMES, STALE_TIMES } from '@/lib/constants';
import type { TemplatesListParams } from '@/types/api';

export function useTemplates(params: TemplatesListParams = {}) {
  return useQuery({
    queryKey: templateKeys.list(params),
    queryFn: () => analyticsApi.templates(params),
    staleTime: STALE_TIMES.long,
    gcTime: GC_TIMES.long,
    placeholderData: keepPreviousData,
  });
}

export function useTemplateDetail(templateHash: string | undefined, periodDays = 30) {
  return useQuery({
    queryKey: templateKeys.detail(templateHash ?? '', periodDays),
    queryFn: () => {
      if (!templateHash) throw new Error('templateHash requis');
      return analyticsApi.templateDetail(templateHash, periodDays);
    },
    enabled: !!templateHash,
    staleTime: STALE_TIMES.long,
    gcTime: GC_TIMES.long,
  });
}
